import { Dialog, DialogActions, DialogTitle, GrayOutlinedButton, PrimaryButton, SnackBarContext } from '@frontend-workspace/react-shared-lib';
import { IActiveUser } from '../_models/active-user';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useMakeRequestHook } from '../requestUtils';

/* eslint-disable-next-line */
export interface ReleaseSessionDialogProps {
  onClose: () => void,
  selectedSession: IActiveUser,
  getData: () => void
}

export function ReleaseSessionDialog(props: ReleaseSessionDialogProps) {
  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const makeRequest = useMakeRequestHook();
  const handleReleaseLoan = () => {
    makeRequest(`licenses/action/releaseSession/${props.selectedSession.sessionId}`, 'PUT').then(result => {
      setSnackbarMessage({ content: t("releaseSession.loanReleasedItMayTakeSomeTimeForItToAppear"), type: "success" });
      props.getData();
      props.onClose();
    });
  };
  return (
    <Dialog
      open={true}
      onClose={() => props.onClose()}
      maxWidth="md">
      <DialogTitle className='mb-4'>
        {t("standard.freeUpLoans")}: <span className='MuiTypography-body3'>{props.selectedSession?.personName} ({props.selectedSession?.licenseNumber})</span>
      </DialogTitle>
      <DialogActions>
        <PrimaryButton
          variant="contained"
          size='large'
          onClick={handleReleaseLoan}
          className='minButtonWidth'>
          {t("standard.freeUpLoans")}
        </PrimaryButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t("standard.cancel")}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default ReleaseSessionDialog;
